/**
 * Featured Collection sort dropdown.
 *
 * Re-fetches this exact section rendered against its own collection's URL
 * (Section Rendering API: `{collection.url}?sort_by=X&section_id=Y`), which
 * gives native, full-catalog Shopify sorting (not just a client-side
 * reshuffle of the handful of products already on the page) while keeping
 * every custom card treatment (floating add-to-cart, etc.) intact, since
 * it's the same section — and same render params — being re-rendered.
 */
document.querySelectorAll('[data-fc-sort]').forEach((sortWrapper) => {
  const select = sortWrapper.querySelector('select');
  const collectionUrl = sortWrapper.dataset.collectionUrl;
  const sectionId = sortWrapper.dataset.sectionId;
  if (!select || !collectionUrl || !sectionId) return;

  const sliderId = `Slider-${sectionId}`;
  const currentList = document.getElementById(sliderId);
  if (!currentList) return;

  const sliderComponent = currentList.closest('slider-component');
  const statusTemplate = sortWrapper.dataset.statusTemplate || '';
  const errorMessage = sortWrapper.dataset.errorMessage || '';

  let statusElement = sortWrapper.querySelector('.fc-sort__status');
  if (!statusElement) {
    statusElement = document.createElement('div');
    statusElement.className = 'fc-sort__status visually-hidden';
    statusElement.setAttribute('role', 'status');
    statusElement.setAttribute('aria-live', 'polite');
    sortWrapper.appendChild(statusElement);
  }

  select.addEventListener('change', () => {
    const sortValue = select.value;
    const url = `${collectionUrl}?sort_by=${encodeURIComponent(sortValue)}&section_id=${encodeURIComponent(sectionId)}`;

    select.disabled = true;
    sortWrapper.setAttribute('aria-busy', 'true');

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Sort request failed');
        return response.text();
      })
      .then((responseText) => {
        const parsedDocument = new DOMParser().parseFromString(responseText, 'text/html');
        const newList = parsedDocument.getElementById(sliderId);
        if (!newList) throw new Error('Sorted section markup not found');

        currentList.innerHTML = newList.innerHTML;

        if (sliderComponent && typeof sliderComponent.resetPages === 'function') {
          sliderComponent.resetPages();
        }

        const productCount = currentList.querySelectorAll('[id^="Slide-"]').length;
        statusElement.textContent = statusTemplate.replace('[[count]]', productCount);
      })
      .catch(() => {
        statusElement.textContent = errorMessage;
      })
      .finally(() => {
        select.disabled = false;
        sortWrapper.removeAttribute('aria-busy');
      });
  });
});
